exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-gurus-layout p[data-v-3c543387]{margin:0}.tabs[data-v-3c543387]{display:flex;justify-content:center;margin-top:10px;margin-bottom:20px}.tabs .active[data-v-3c543387]{background-color:#13aff0}.tabs .left[data-v-3c543387],.tabs .right[data-v-3c543387]{padding:15px 30px;color:#fff;font-weight:600;font-family:Architects Daughter;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c543387","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyGurus/index.vue
// module id = 557
// module chunks = 0